module.exports = "/images/vendor/desiigner-svg/svg/ui/arrow-top-left.svg?ca1074fee035f2816462ee484d3e25fa";